import { IRoleType } from "@/models/role";
import { lazy } from "react";

import RouteGuard from "@/components/RouteGuard";
const PharmacyClinicDiagnostic = lazy(
  () => import("@/views/PharmacyClinicDiagnostic")
);
const Profile = lazy(() => import("@/views/Common/Profile"));
const ServerError = lazy(() => import("@/views/Common/ServerError"));

const allowedRoles = [IRoleType.PHARMACY, IRoleType.DIAGNOSTIC_CENTER];

const withGuard = (component: React.ReactNode) => (
  <RouteGuard allowedRoles={allowedRoles}>{component}</RouteGuard>
);

const CommonRoutes = [
  {
    path: "/orders",
    component: withGuard(<PharmacyClinicDiagnostic />),
  },
  {
    path: "/profile-details",
    component: withGuard(<Profile />),
  },
  {
    path: "/server-error",
    component: <ServerError />,
  },
];

export default CommonRoutes;
